var $2b6e161c9edcf319$exports = {};
const $2b6e161c9edcf319$var$textarea = document.querySelector(".textarea--js");
const $2b6e161c9edcf319$var$save = document.querySelector(".button-save--js");
const $2b6e161c9edcf319$var$load = document.querySelector(".button-load--js");
const $2b6e161c9edcf319$var$check = document.querySelector(".check--js");
$2b6e161c9edcf319$var$save.addEventListener("click", ()=>{
    localStorage.setItem("save", $2b6e161c9edcf319$var$textarea.value);
});
const $2b6e161c9edcf319$var$fromStorage = localStorage.getItem("save");
console.log($2b6e161c9edcf319$var$fromStorage);
$2b6e161c9edcf319$var$load.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$textarea.value = $2b6e161c9edcf319$var$fromStorage;
});
let $2b6e161c9edcf319$var$color = "green";
$2b6e161c9edcf319$var$check.addEventListener("click", ()=>{
    const textLength = $2b6e161c9edcf319$var$textarea.value.length;
    $2b6e161c9edcf319$var$textarea.classList.remove("text-gray-400");
    $2b6e161c9edcf319$var$textarea.classList.remove(`text-${$2b6e161c9edcf319$var$color}-500`);
    if (textLength <= 10) $2b6e161c9edcf319$var$color = "red";
    else if (textLength > 10 && textLength <= 20) $2b6e161c9edcf319$var$color = "blue";
    else $2b6e161c9edcf319$var$color = "green";
    $2b6e161c9edcf319$var$textarea.classList.add(`text-${$2b6e161c9edcf319$var$color}-500`);
});


//# sourceMappingURL=index.946a8950.js.map
